const namespaced = true

const state = {
    sessionCache: [],
    presentationCache: [],
    personCache: [],
    abstractCache: [],
    industryCache: [],

}

const actions = {

}
const mutations = {
    setCache: (state, data) => {
        let items = data.items;
        let area = data.area;
        console.log('cache', area, items)
        state[area+ 'Cache'] = items
    },
}
const getters = {
}

export const search = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
